module.exports = __webpack_public_path__ + "img/chk_payment.97585fe1.svg";